import { formatValue } from "../utils/helpers";
import metricMetadataIcon from '../assets/metric-metadata-icon.svg';
import { useState } from "react";
import MetricMetadataModal from "./MetricMetadataModal";
import { MetricMetadata } from "../services/types";
import { fetchMetricMetadata } from "../utils/dashboardUtils";

interface DisaggregateMetricCardProps {
    id: number;
    title: string;
    subText: string;
    value?: number;
    unit?: string;
    svg: string;
    showMetadataIcon?: boolean;
};

const DisaggregateMetricCard = ({ id, title, subText, value, unit, svg, showMetadataIcon = true }: DisaggregateMetricCardProps) => {
    const [showMetadata, setShowMetadata] = useState(false);
    const [metadata, setMetadata] = useState<MetricMetadata[] | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const handleClick = async () => {
        setShowMetadata(prev => !prev);

        if (!metadata) { // Only fetch if metadata is not already loaded
            setLoading(true);
            try {
                const result = await fetchMetricMetadata(id);
                setMetadata(result ? result.data : null);
            } catch (error) {
                setError(error as Error);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="ml-2 mr-4 my-2 w-48">
            <div className="flex flex-col items-start w-full">
                <div className="flex items-end w-28 justify-between">
                    <img src={svg} alt={`${title} icon`} className="w-10 h-10 text-blue-500" />
                    {showMetadataIcon && 
                    <button className="mb-1" onClick={handleClick}>
                        <img src={metricMetadataIcon} alt="Metric metadata icon" />
                    </button>
                    }
                </div>
                <p className="text-gotham-gray text-sm font-bold w-full">{title}</p>
                <div className="flex items-baseline w-full justify-start">
                    <p className="text-gotham-gray text-xs mr-2">{subText} </p>
                    <h2 className="text-gotham-gray text-md font-bold">{value && unit && formatValue(value, unit)}</h2>
                </div>
            </div>
            <MetricMetadataModal
                isOpen={showMetadata}
                onClose={handleClick}
                metadata={metadata}
                svg={svg}
                loading={loading}
                error={error}
            />
        </div>
    );
};


export default DisaggregateMetricCard;
